import {
  Backdrop,
  Box,
  Typography,
  useMediaQuery,
  useTheme,
} from '@material-ui/core'
import { observer } from 'mobx-react-lite'
import useStyles from './InsuranceVerificationOverlay.styles'
import { useDMEStore } from '../../store'
import Arch from './shapes/Arch'
import Burst from './shapes/Burst'
import Clover from './shapes/Clover'
import Vector from './shapes/Vector'
import Spinner from './Spinner'

export const InsuranceVerificationOverlay = observer(() => {
  const classes = useStyles()
  const theme = useTheme()
  const isSmallScreen = !useMediaQuery(theme.breakpoints.up('sm'))
  const {
    ui: { globalComponents },
  } = useDMEStore()
  const open =
    globalComponents.Overlay.open &&
    globalComponents.Overlay.name === 'insuranceVerification'

  return (
    <Backdrop className={classes.overlay} open={open}>
      <div className={classes.contentContainer}>
        <div>
          <Typography className={classes.heading} color="primary" variant="h3">
            You're almost there!
          </Typography>
          <Typography
            className={classes.subHeading}
            color="primary"
            variant="h5"
          >
            We are verifying your insurance is active and in our network.
          </Typography>
        </div>
        <Box mb={12}>
          <Spinner />
        </Box>
        <div className={classes.subtextContainer}>
          <Typography component="p" variant="caption">
            <strong>How long are we talking?</strong>
          </Typography>
          <Typography component="p" variant="caption">
            For most this will take about 30 seconds but it can take as long as
            a few minutes.
          </Typography>
        </div>
      </div>
      {isSmallScreen && (
        <>
          <Arch />
          <Burst />
          <Vector />
          <Clover />
        </>
      )}
    </Backdrop>
  )
})

export default InsuranceVerificationOverlay
